const typeOptions = [
	{ key: 1, text: "Detallado", value: "Detallado" },
	{ key: 2, text: "Resumido", value: "Resumido" },
	{ key: 3, text: "Resumido Empleado", value: "Resumido empleado" },
	{ key: 4, text: "Resumido Sucursal", value: "Resumido sucursal" },
	{ key: 5, text: "Resumido Mes", value: "Resumido mes" },
	{ key: 6, text: "Resumido Gráfico", value: "Resumido grafico" },
];

export default typeOptions;
export const contactOption = [
	{
		label: "ID",
		key: "id",
		format: "string",
		dataPosition: "center",
		width: 1,
	},
	{
		label: "Plataforma",
		key: "contact.channel",
		format: "string",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Nombre",
		key: "name",
		format: "string",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Teléfono",
		key: "phone",
		format: "phone",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Correo",
		key: "email",
		format: "string",
		headerPosition: "left",
		dataPosition: "left",
		width: 16,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
];

export const contactFilterOption = [
	{ key: "name", text: "Nombre", value: "name" },
	{ key: "code", text: "Código", value: "code" },
	{ key: "phone", text: "Teléfono", value: "phone" },
	{ key: "email", text: "Email", value: "email" },
	{ key: "cedula", text: "Cédula", value: "cedula" },
	{ key: "city", text: "Ciudad", value: "city" },
	{ key: "zone", text: "Zona", value: "zone" },
	{ key: "sector", text: "Sector", value: "sector" },
];
